import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const branch = {

    namespaced: true,

    state:
    {
        ...baseStates,

        profile: {},
        profileLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        profile: state => state.profile,
    },
};
